import { styled } from 'styled-components';

import { LegacyButton } from '#/components/LegacyButton/LegacyButton';
import { StyledNativeLinkWithRef } from '#/components/Link/StyledNativeLinkWithRef';
import { colors, fontWeights, transition } from '#/theme/theme';

export const PageLink = styled(StyledNativeLinkWithRef)`
  display: flex;
  padding: 4px;
  margin: 0 10px;
  color: ${colors.mediumContentGrey};
  font-weight: ${fontWeights.semiBold};

  &,
  &:active,
  &:visited,
  &:hover {
    text-decoration: none;
  }

  &:hover,
  &:focus {
    color: ${colors.hoverBlue};
  }
`;

export const CurrentPage = styled(LegacyButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
  background-color: ${colors.brandBlue};
  border-radius: 50%;
  text-align: center;
  width: 40px;
  height: 40px;
  color: white;
  font-weight: ${fontWeights.semiBold};
`;

export const ArrowLink = styled(StyledNativeLinkWithRef)<{
  $disabled?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;

  &,
  svg {
    transition: all ${transition};
  }

  svg {
    * {
      fill: ${colors.brandBlue};
    }
  }

  ${(props) =>
    props.$disabled &&
    `
    pointer-events: none;
    svg {
      * {
        fill: ${colors.elementGrey};
      }
    }
  `}
  &:hover, &:focus {
    background: ${colors.calloutGrey};

    svg {
      * {
        fill: ${colors.hoverBlue};
      }
    }
  }
`;
